import { useState, useEffect } from 'react';
import {Space, Row, Button, Table, Divider, message, PageHeader, Statistic} from 'antd';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable'
import { DeleteOutlined } from '@ant-design/icons';
import ModelAdd from './ModelAdd';
import ModelUpdate from './ModelUpdate';
import axios from 'axios';


const ModelComponent = () => {

    const [modelData, setModelData] = useState()
    const [modelTotal, setModelTotal] = useState([])

    const getAllModel = () => {
        let getModel = `${FetchVariable.Heroku}/model/`
        axios.get(getModel)
            .then((res) => {
                let data =res.data
                setModelData(data)
                setModelTotal(data.length)
            })
        };
    
    function deleteModel (deleteID){
            let deleteModel = `${FetchVariable.Heroku}/model/`+deleteID
            axios.delete(deleteModel)
            .then(() => {
                getAllModel()
                message.error('The model is deleted')
            })
        }

    const addModel = (addModelData)=>{
            let apiURL = `${FetchVariable.Heroku}/model/`
            axios.post(apiURL, addModelData)
            .then(() => {
                getAllModel()
            })
            .catch(err=>{console.log(err)})
        }
    const updateModel = (updateModel)=>{
            let apiURL = `${FetchVariable.Heroku}/model/`
            axios.put(apiURL, updateModel)
            .then(() => {
                getAllModel()
            })
            .catch(err=>{console.log(err)})
        }

    useEffect(() => {
        getAllModel();
    }, [])

        let makeFilter = []
        const key = 'text';

        modelData?.forEach((e)=>{makeFilter.push({text:e.Make,value:e.Make})})
        const uniqueMakeFilter = [...new Map(makeFilter.map(item =>
        [item[key], item])).values()];

        let modelFilter = []
        
        modelData?.forEach((e)=>{modelFilter.push({text:e.Model,value:e.Model})})
        const uniqueModelFilter = [...new Map(modelFilter.map(item =>
            [item[key], item])).values()];
    
        const ModelColums = [
        {
            title: 'Model ID',
            dataIndex: 'ModelID',
            key: 'ModelID',
        },
        {
            title: 'Make ID',
            dataIndex: 'MakeID',
            key: 'MakeID',
        },
        {
            title: 'Make',
            dataIndex: 'Make',
            key: 'Make',
            filters: uniqueMakeFilter,
            filterSearch: true,
            onFilter: (value, record) => record.Make.indexOf(value) === 0,
        },
        {
            title: 'Model Name',
            dataIndex: 'Model',
            key: 'Model',
            filters: uniqueModelFilter,
            filterSearch: true,
            onFilter: (value, record) => record.Model.indexOf(value) === 0,
        },
        {
            title: 'Action',
            key: 'action',
            render: (record) => (
              <Space size="middle">
                <ModelUpdate record={record} updateModel={updateModel}/>
                <Button onClick={()=> deleteModel(record.ModelID) } type="primary" danger icon={<DeleteOutlined />}></Button>
              </Space>
            ),
          },
    ]

    return(
        <>
            <PageHeader
            className="site-page-header"
            title="Car Models Management"
            extra={[ 
                <ModelAdd key='addModel' addModel={addModel}/>,
            ]}
            >
                <Statistic title="Model Total" value={modelTotal} />
            </PageHeader>

            <Divider />
            <Row>
                <Table columns={ModelColums} dataSource={modelData} rowKey={(record)=>record.ModelID} scroll={{x:1500, y:1000}}/>
            </Row>
        </>
    )
}

export default ModelComponent